import { Box, Typography, Divider, Grid, useTheme, useMediaQuery } from "@mui/material";

export const EndpointLogin = (props) => {
  const { onClick } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const sectionStyle = {
    my: isMobile ? 2 : 4,
  };

  const titleStyle = {
    fontSize: isMobile ? "1rem" : "1.10rem",
    color: "primary.dark",
    fontWeight: "700",
  };

  const contentStyle = {
    fontSize: isMobile ? "0.9rem" : "1rem",
    color: "primary.dark",
    my: isMobile ? 0.5 : 1,
    wordBreak: "break-word",
    overflowWrap: "break-word",
  };

  const codeBlockStyle = {
    my: isMobile ? 1 : 2,
    p: isMobile ? 1 : 2,
    background: "#f3f7fa",
    borderRadius: "4px",
    overflowX: "auto",
  };

  const codeTextStyle = {
    fontFamily: "Courier New,Courier,monospace!important",
    fontSize: isMobile ? "0.8rem" : "0.94rem",
    color: "primary.dark",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  };

  return (
    <Box {...props}>
      <Box sx={sectionStyle}>
        <Typography sx={titleStyle}>Descripción</Typography>
        <Typography sx={contentStyle}>
          Api para autenticación y generación de token de sesión. Este token es
          necesario para poder generar el link de formulario de receta.
        </Typography>
      </Box>

      <Box sx={sectionStyle}>
        <Typography sx={titleStyle}>Resource URL</Typography>
        <Typography sx={{ ...contentStyle, color: "#067acc" }}>
          Aplicacion/login
        </Typography>
      </Box>

      <Box sx={sectionStyle}>
        <Typography sx={titleStyle}>Parámetros</Typography>
        <Typography sx={{ ...contentStyle, fontSize: isMobile ? "0.85rem" : "0.92rem" }}>
          No se requieren parámetros
        </Typography>
      </Box>

      <Box sx={sectionStyle}>
        <Typography sx={titleStyle}>Request Body</Typography>
        <Box sx={codeBlockStyle}>
          <Typography sx={codeTextStyle}>{"{"}</Typography>
          <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
            "username": "string",
          </Typography>
          <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
            "accessKey": "string"
          </Typography>
          <Typography sx={codeTextStyle}>{"}"}</Typography>
        </Box>
        <Box sx={{ px: isMobile ? 1 : 2 }}>
          <Typography sx={{ ...codeTextStyle, fontWeight: "bold", mb: 1 }}>
            username:
          </Typography>
          <Typography sx={{ ...codeTextStyle, fontSize: isMobile ? "0.8rem" : "0.95rem", mb: 2 }}>
            Se crea por el administrador al dar de alta la aplicación en el
            sistema. Es única por aplicación. Para acceder a este valor de
            la aplicación ingresar al detalle.
          </Typography>
          <Typography sx={{ ...codeTextStyle, fontWeight: "bold", mb: 1 }}>
            accessKey:
          </Typography>
          <Typography sx={{ ...codeTextStyle, fontSize: isMobile ? "0.8rem" : "0.95rem" }}>
            Se crea automáticamente al crear una nueva aplicación. Para
            acceder a este valor de la aplicación ingresar al detalle.
          </Typography>
        </Box>
      </Box>

      <Box sx={sectionStyle}>
        <Typography sx={titleStyle}>Request example</Typography>
        <Box sx={codeBlockStyle}>
          <Box sx={{ whiteSpace: "pre-wrap" }}>
            <Typography sx={codeTextStyle}>{"{"}</Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "username": "app-data-test",
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "accessKey": "BP-lg09hBKaaaffFDLSa4DnOAhFFpWvr2aWw"
            </Typography>
            <Typography sx={codeTextStyle}>{"}"}</Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={sectionStyle}>
        <Typography sx={titleStyle}>Response examples</Typography>
        <Box sx={{ ...codeBlockStyle, background: "#F7FAEC" }}>
          <Box sx={{ whiteSpace: "pre-wrap" }}>
            <Typography sx={{ ...codeTextStyle, fontWeight: "bold" }}>
              Code: 200 - <span style={{ fontWeight: "Bold" }}>Status: OK</span>
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Typography sx={codeTextStyle}>{"{"}</Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "result": {"{"}
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 4 : 6 }}>
              "accessToken":
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjE1NmU5Y2YzLWY2YTYtNDJiZS05NjFmLWFiNz",
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 4 : 6 }}>
              "refreshToken":
              "aAbkowtAMNRqXDFZX6IBwzgDahh8KQXgqW453Z6lYpihBSojjAa3KeN1ahuLk0IAuBBnvQLMZ9L/SzEM3GI0Vw=="
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              {"},"}
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "status": "Ok",
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "successMessage": "",
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "errors": {"[]"},
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "validationErrors": {"[]"}
            </Typography>
            <Typography sx={codeTextStyle}>{"}"}</Typography>
          </Box>
        </Box>
        <Box sx={{ ...codeBlockStyle, background: "#F7FAEC", mt: 2 }}>
          <Box sx={{ whiteSpace: "pre-wrap" }}>
            <Typography sx={{ ...codeTextStyle, fontWeight: "bold" }}>
              Code: 200 - <span style={{ fontWeight: "Bold" }}>Status: Error</span>
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Typography sx={codeTextStyle}>{"{"}</Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "result": null,
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "status": "Error",
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "successMessage": "",
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "errors": {"["}
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 4 : 6 }}>
              "Error es las credenciales. Por favor intente nuevamente"
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              {"],"}
            </Typography>
            <Typography sx={{ ...codeTextStyle, pl: isMobile ? 2 : 3 }}>
              "validationErrors": {"[]"},
            </Typography>
            <Typography sx={codeTextStyle}>{"}"}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
